'use strict';

const { h } = require('phy');

const Header = require('../../shared/views/header');
const RedemptionProvider = require('../../redemption/views/redemption-provider');
const SecondaryTitle = require('../../coupons/views/secondary-title');
const CouponsList = require('../../coupons/views/coupons-list');
const Carousel = require('../../shared/views/carousel');
const SidebarBrowseLetter = require('../../merchant/views/sidebar-browse-letter');

function getCarouselOptions(coupons) {
  return {
    className: 'carousel-sidebar',
    coupons,
    autoplay: true,
    navigation: false,
    options: {
      perPage: 1,
    },
  };
}

function TopOffers({ payload, deps }) {
  const {
    seoMetaData: { h1Override },
    navigationMerchants,
    couponsForList,
    advertsForCarousel,
  } = payload;
  const { datetime, routes } = deps;

  return h('article', [
    h(RedemptionProvider, { routes }),
    h(Header, {
      routes,
      activePage: 'top-offers',
      merchants: navigationMerchants,
      titleText: h1Override,
      resourceKey: 'modules.top_offers.PageHeadingFormat',
      params: {
        0: datetime().format('MMMM YYYY'),
      },
    }),
    h('section.container', [
      h('.layout', [
        h(
          '.layout-content',
          {
            'data-bhw': 'TopOffersCouponsList',
          },
          [
            couponsForList.length > 0 &&
              h(SecondaryTitle, {
                resourceKey: '.PageSubHeadingFormat',
                params: {
                  0: couponsForList[0].calloutValue,
                  1: couponsForList[0].merchant.merchantName,
                },
              }),
            h(CouponsList, { routes, coupons: couponsForList }),
          ]
        ),
        h('.layout-sidebar', [
          advertsForCarousel &&
            advertsForCarousel.length > 0 &&
            h(
              '.carousel-container',
              Carousel({ routes, ...getCarouselOptions(advertsForCarousel) })
            ),
          h(SidebarBrowseLetter, { routes }),
        ]),
      ]),
    ]),
  ]);
}

module.exports = TopOffers;
